<template>
  <div>
    <Spinner v-if="loading" />

    <div class='owned-books' v-else>
      <BooksGrid
          v-if="books && books.length > 0"
          :books='books'
          title="Your favorite books"
      />

      <div class="cta-card" v-else>
        <h3>De boekenplank is leeg!</h3>
        <p class="light">Je hebt op dit moment nog geen boeken in jouw bezit. Ga snel naar de webshop en schaf jouw Broodje Dunner
          e-book(s) aan!</p>
        <a
            class='btn'
            target="_blank"
            href="https://broodjedunner.nl"
            style="margin-bottom: 10px"
        >
          Naar de webshop
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import {
  mapGetters,
  mapActions,
} from "vuex";

import BooksGrid from "./BooksGrid.vue";
import BooksSlider from "./BooksSlider.vue";
import Spinner from "../../blocks/Spinner.vue";

export default {
  name: "Books",
  data() {
    return {
      books: [],
      loading: true,
    };
  },
  components: {
    BooksSlider,
    BooksGrid,
    Spinner,
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("book", [
      "getOwnedBooks"
    ]),
    init() {
      this.getOwnedBooks().then(response => {
        this.books = response;
        this.loading = false;
      });
    },
  },
};
</script>
